import styled from "styled-components";

export const StyledSearchInfo = styled.div`
  margin: 2rem auto;
  /* overflow-x: auto; */
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  width: 95%;
`